<!--
	Clicks are kept off `document` so a card row swiped open for delete stays open while the
	confirmation is up, and is still there when the user backs out.

	Nothing is held off while the delete is in flight: the sheet leaves with the request, so the
	only thing `cancelling` still guards is a second tap landing during the closing animation.
-->
<app-bottom-sheet #sheet [ariaLabel]="sheetLabel()" [blockOutsideClicks]="true" (closed)="onSheetClosed()">
	<ng-template #body>
		<ui-empty-state
			class="py-4"
			variant="error"
			data-cy="order-cancel-confirm-text"
			[title]="confirmTitle()"
			[showDescription]="false" />
	</ng-template>

	<ng-template #footer>
		<div class="flex w-full items-center gap-2 py-4" data-cy="order-cancel-confirm-actions">
			<ui-button
				#confirmButton
				type="button"
				class="min-w-0 flex-1"
				variant="red"
				size="lg"
				extraButtonClasses="w-full"
				data-cy="order-cancel-confirm-submit"
				[label]="confirmLabel()"
				[loading]="cancelling()"
				[disabled]="cancelling()"
				(click)="onConfirm()">
				<ui-icon leftIcon [iconName]="'delete'" />
			</ui-button>
			<ui-button
				type="button"
				class="shrink-0 grow-0"
				variant="mute"
				size="lg"
				data-cy="order-cancel-confirm-dismiss"
				label="انصراف"
				[disabled]="cancelling()"
				(click)="onDismiss()" />
		</div>
	</ng-template>
</app-bottom-sheet>
